export const RESULT_CODE_AUTO_SUBMIT_SUCCESS = 12;

export const RESULT_CODE_SUBMIT_PENDING_SUCCESS = 0;
